export default __webpack_public_path__ + "static/media/ha.22bbcd24.jpg";